var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -74 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1055016974,
    x2: 260.1330560896,
    xlinkHref: "#lg1",
    y1: 16.5916493736,
    y2: 114.9760053736
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg2",
    y1: 80.5402760672,
    y2: 130.2882252864
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8771807974,
    x2: 25.4819497728,
    xlinkHref: "#lg1",
    y1: 67.1546828646,
    y2: 38.75945184
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 61.741203,
    x2: 20.8807744624,
    xlinkHref: "#lg2",
    y1: 75.0187050672,
    y2: 34.1582765296
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 33.2130527026,
    x2: 51.7415375268,
    xlinkHref: "#lg3",
    y1: 46.490655162,
    y2: 65.019039594
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7228852026,
    x2: 71.3277545702,
    xlinkHref: "#lg1",
    y1: 67.1546828646,
    y2: 38.75945184
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5870077974,
    x2: 66.7265792598,
    xlinkHref: "#lg2",
    y1: 75.0187050672,
    y2: 34.1582765296
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0588575,
    x2: 97.587241932,
    xlinkHref: "#lg4",
    y1: 46.490655162,
    y2: 65.019039594
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 145.56869,
    x2: 117.1734589754,
    xlinkHref: "#lg1",
    y1: 67.1546828646,
    y2: 38.75945184
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4327122026,
    x2: 112.572283665,
    xlinkHref: "#lg2",
    y1: 75.0187050672,
    y2: 34.1582765296
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1591,
    stopColor: "#ab9ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#9f9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    stopColor: "#8c9beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6178,
    stopColor: "#709aef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7686,
    stopColor: "#4d99f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9167,
    stopColor: "#2297fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0796ff"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 124.9046622974,
    x2: 143.4330467294,
    xlinkHref: "#lg5",
    y1: 46.490655162,
    y2: 65.019039594
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1055016974,
    x2: 260.1330560896,
    xlinkHref: "#lg1",
    y1: 141.5737140572,
    y2: 239.9580700572
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg2",
    y1: 205.5223407508,
    y2: 255.27028997
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8771807974,
    x2: 25.4819497728,
    xlinkHref: "#lg1",
    y1: 192.1367475482,
    y2: 163.7415165236
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 61.741203,
    x2: 20.8807744624,
    xlinkHref: "#lg2",
    y1: 200.0007697508,
    y2: 159.1403412132
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 33.2130527026,
    x2: 51.7415375268,
    xlinkHref: "#lg3",
    y1: 171.4727198456,
    y2: 190.0011042776
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7228852026,
    x2: 71.3277545702,
    xlinkHref: "#lg1",
    y1: 192.1367475482,
    y2: 163.7415165236
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear17",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5870077974,
    x2: 66.7265792598,
    xlinkHref: "#lg2",
    y1: 200.0007697508,
    y2: 159.1403412132
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear18",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0588575,
    x2: 97.587241932,
    xlinkHref: "#lg4",
    y1: 171.4727198456,
    y2: 190.0011042776
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear19",
    gradientUnits: "userSpaceOnUse",
    x1: 145.56869,
    x2: 117.1734589754,
    xlinkHref: "#lg1",
    y1: 192.1367475482,
    y2: 163.7415165236
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear20",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4327122026,
    x2: 112.572283665,
    xlinkHref: "#lg2",
    y1: 200.0007697508,
    y2: 159.1403412132
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear21",
    gradientUnits: "userSpaceOnUse",
    x1: 124.9046622974,
    x2: 143.4330467294,
    xlinkHref: "#lg5",
    y1: 171.4727198456,
    y2: 190.0011042776
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear22",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1055016974,
    x2: 260.1330560896,
    xlinkHref: "#lg1",
    y1: 266.5557787408,
    y2: 364.9401347408
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear23",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg2",
    y1: 330.5044054344,
    y2: 380.2523546536
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear24",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8771807974,
    x2: 25.4819497728,
    xlinkHref: "#lg1",
    y1: 317.1188122318,
    y2: 288.7235812072
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear25",
    gradientUnits: "userSpaceOnUse",
    x1: 61.741203,
    x2: 20.8807744624,
    xlinkHref: "#lg2",
    y1: 324.9828344344,
    y2: 284.1224058968
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear26",
    gradientUnits: "userSpaceOnUse",
    x1: 33.2130527026,
    x2: 51.7415375268,
    xlinkHref: "#lg3",
    y1: 296.454684137,
    y2: 314.9831689612
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear27",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7228852026,
    x2: 71.3277545702,
    xlinkHref: "#lg1",
    y1: 317.1188122318,
    y2: 288.7235812072
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear28",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5870077974,
    x2: 66.7265792598,
    xlinkHref: "#lg2",
    y1: 324.9828344344,
    y2: 284.1224058968
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear29",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0588575,
    x2: 97.587241932,
    xlinkHref: "#lg4",
    y1: 296.454684137,
    y2: 314.9831689612
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear30",
    gradientUnits: "userSpaceOnUse",
    x1: 145.56869,
    x2: 117.1734589754,
    xlinkHref: "#lg1",
    y1: 317.1188122318,
    y2: 288.7235812072
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear31",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4327122026,
    x2: 112.572283665,
    xlinkHref: "#lg2",
    y1: 324.9828344344,
    y2: 284.1224058968
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear32",
    gradientUnits: "userSpaceOnUse",
    x1: 124.9046622974,
    x2: 143.4330467294,
    xlinkHref: "#lg5",
    y1: 296.454684137,
    y2: 314.9831689612
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear33",
    gradientUnits: "userSpaceOnUse",
    x1: 458.9205548394,
    x2: 315.0251016368,
    xlinkHref: "#lg2",
    y1: 325.2468659204,
    y2: 157.9265995152
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear34",
    gradientUnits: "userSpaceOnUse",
    x1: 477.5519416686,
    x2: 348.3806108712,
    xlinkHref: "#lg2",
    y1: 263.5818606002,
    y2: 145.7882790054
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear35",
    gradientUnits: "userSpaceOnUse",
    x1: 517.9348045108,
    x2: 454.3531113082,
    xlinkHref: "#lg2",
    y1: 163.6159258814,
    y2: 102.7113914762
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear36",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5764425324,
    x2: 429.9137345324,
    y1: 98.347744111,
    y2: 279.053704111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#02e3b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#08d7ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#12c2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#21a698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8029,
    stopColor: "#338189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#495577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m495.121094 114.230469h-478.242188c-9.320312 0-16.878906-7.558594-16.878906-16.878907v-80.472656c0-9.324218 7.558594-16.878906 16.878906-16.878906h478.242188c9.320312 0 16.878906 7.558594 16.878906 16.878906v80.472656c0 9.320313-7.558594 16.878907-16.878906 16.878907zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 54.101562v43.25c0 9.320313 7.558594 16.878907 16.878906 16.878907h478.242188c9.320312 0 16.878906-7.558594 16.878906-16.878907v-43.25zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m58.898438 52.429688c0 10.90625-8.839844 19.746093-19.746094 19.746093-10.902344 0-19.742188-8.839843-19.742188-19.746093 0-10.902344 8.839844-19.742188 19.742188-19.742188 10.90625 0 19.746094 8.839844 19.746094 19.742188zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m48.003906 44.050781c-2.222656-2.347656-5.363281-3.820312-8.851562-3.820312-6.738282 0-12.199219 5.460937-12.199219 12.199219 0 3.492187 1.472656 6.628906 3.820313 8.855468l23.652343 23.648438c2.222657 2.347656 5.363281 3.824218 8.851563 3.824218 6.738281 0 12.203125-5.464843 12.203125-12.203124 0-3.488282-1.472657-6.628907-3.824219-8.851563zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m51.355469 52.429688c0 6.738281-5.464844 12.203124-12.203125 12.203124-6.738282 0-12.199219-5.464843-12.199219-12.203124 0-6.738282 5.460937-12.199219 12.199219-12.199219 6.738281 0 12.203125 5.460937 12.203125 12.199219zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m104.742188 52.429688c0 10.90625-8.839844 19.746093-19.742188 19.746093-10.90625 0-19.746094-8.839843-19.746094-19.746093 0-10.902344 8.839844-19.742188 19.746094-19.742188 10.902344 0 19.742188 8.839844 19.742188 19.742188zm0 0",
    fill: "url(#linear5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m93.851562 44.050781c-2.222656-2.347656-5.363281-3.820312-8.851562-3.820312-6.738281 0-12.203125 5.460937-12.203125 12.199219 0 3.492187 1.472656 6.628906 3.824219 8.855468l23.648437 23.648438c2.226563 2.347656 5.363281 3.824218 8.855469 3.824218 6.738281 0 12.199219-5.464843 12.199219-12.203124 0-3.488282-1.472657-6.628907-3.820313-8.851563zm0 0",
    fill: "url(#linear6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m97.199219 52.429688c0 6.738281-5.460938 12.203124-12.199219 12.203124s-12.203125-5.464843-12.203125-12.203124c0-6.738282 5.464844-12.199219 12.203125-12.199219s12.199219 5.460937 12.199219 12.199219zm0 0",
    fill: "url(#linear7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m150.589844 52.429688c0 10.90625-8.839844 19.746093-19.746094 19.746093-10.902344 0-19.742188-8.839843-19.742188-19.746093 0-10.902344 8.839844-19.742188 19.742188-19.742188 10.90625 0 19.746094 8.839844 19.746094 19.742188zm0 0",
    fill: "url(#linear8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m139.699219 44.050781c-2.226563-2.347656-5.363281-3.820312-8.855469-3.820312-6.738281 0-12.199219 5.460937-12.199219 12.199219 0 3.492187 1.472657 6.628906 3.820313 8.855468l23.652344 23.648438c2.222656 2.347656 5.363281 3.824218 8.851562 3.824218 6.738281 0 12.203125-5.464843 12.203125-12.203124 0-3.488282-1.472656-6.628907-3.824219-8.851563zm0 0",
    fill: "url(#linear9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m143.046875 52.429688c0 6.738281-5.464844 12.203124-12.203125 12.203124s-12.203125-5.464843-12.203125-12.203124c0-6.738282 5.464844-12.199219 12.203125-12.199219s12.203125 5.460937 12.203125 12.199219zm0 0",
    fill: "url(#linear10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m495.121094 239.214844h-478.242188c-9.320312 0-16.878906-7.558594-16.878906-16.882813v-80.472656c0-9.320313 7.558594-16.878906 16.878906-16.878906h478.242188c9.320312 0 16.878906 7.558593 16.878906 16.878906v80.472656c0 9.324219-7.558594 16.882813-16.878906 16.882813zm0 0",
    fill: "url(#linear11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m0 179.085938v43.246093c0 9.324219 7.558594 16.878907 16.878906 16.878907h478.242188c9.320312 0 16.878906-7.554688 16.878906-16.878907v-43.246093zm0 0",
    fill: "url(#linear12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m58.898438 177.410156c0 10.90625-8.839844 19.746094-19.746094 19.746094-10.902344 0-19.742188-8.839844-19.742188-19.746094 0-10.902344 8.839844-19.742187 19.742188-19.742187 10.90625 0 19.746094 8.839843 19.746094 19.742187zm0 0",
    fill: "url(#linear13)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m48.003906 169.03125c-2.222656-2.347656-5.363281-3.820312-8.851562-3.820312-6.738282 0-12.199219 5.460937-12.199219 12.199218 0 3.492188 1.472656 6.628906 3.820313 8.855469l23.652343 23.648437c2.222657 2.351563 5.363281 3.824219 8.851563 3.824219 6.738281 0 12.203125-5.460937 12.203125-12.203125 0-3.488281-1.472657-6.628906-3.824219-8.851562zm0 0",
    fill: "url(#linear14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m51.355469 177.410156c0 6.742188-5.464844 12.203125-12.203125 12.203125-6.738282 0-12.199219-5.460937-12.199219-12.203125 0-6.738281 5.460937-12.199218 12.199219-12.199218 6.738281 0 12.203125 5.460937 12.203125 12.199218zm0 0",
    fill: "url(#linear15)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m104.742188 177.410156c0 10.90625-8.839844 19.746094-19.742188 19.746094-10.90625 0-19.746094-8.839844-19.746094-19.746094 0-10.902344 8.839844-19.742187 19.746094-19.742187 10.902344 0 19.742188 8.839843 19.742188 19.742187zm0 0",
    fill: "url(#linear16)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m93.851562 169.03125c-2.222656-2.347656-5.363281-3.820312-8.851562-3.820312-6.738281 0-12.203125 5.460937-12.203125 12.199218 0 3.492188 1.472656 6.628906 3.824219 8.855469l23.648437 23.648437c2.226563 2.351563 5.363281 3.824219 8.855469 3.824219 6.738281 0 12.199219-5.460937 12.199219-12.203125 0-3.488281-1.472657-6.628906-3.820313-8.851562zm0 0",
    fill: "url(#linear17)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m97.199219 177.410156c0 6.742188-5.460938 12.203125-12.199219 12.203125s-12.203125-5.460937-12.203125-12.203125c0-6.738281 5.464844-12.199218 12.203125-12.199218s12.199219 5.460937 12.199219 12.199218zm0 0",
    fill: "url(#linear18)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m150.589844 177.410156c0 10.90625-8.839844 19.746094-19.746094 19.746094-10.902344 0-19.742188-8.839844-19.742188-19.746094 0-10.902344 8.839844-19.742187 19.742188-19.742187 10.90625 0 19.746094 8.839843 19.746094 19.742187zm0 0",
    fill: "url(#linear19)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m139.699219 169.03125c-2.226563-2.347656-5.363281-3.820312-8.855469-3.820312-6.738281 0-12.199219 5.460937-12.199219 12.199218 0 3.492188 1.472657 6.628906 3.820313 8.855469l23.652344 23.648437c2.222656 2.351563 5.363281 3.824219 8.851562 3.824219 6.738281 0 12.203125-5.460937 12.203125-12.203125 0-3.488281-1.472656-6.628906-3.824219-8.851562zm0 0",
    fill: "url(#linear20)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m143.046875 177.410156c0 6.742188-5.464844 12.203125-12.203125 12.203125s-12.203125-5.460937-12.203125-12.203125c0-6.738281 5.464844-12.199218 12.203125-12.199218s12.203125 5.460937 12.203125 12.199218zm0 0",
    fill: "url(#linear21)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m495.121094 364.195312h-478.242188c-9.320312 0-16.878906-7.558593-16.878906-16.878906v-80.472656c0-9.324219 7.558594-16.878906 16.878906-16.878906h478.242188c9.320312 0 16.878906 7.558594 16.878906 16.878906v80.472656c0 9.320313-7.558594 16.878906-16.878906 16.878906zm0 0",
    fill: "url(#linear22)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m0 304.066406v43.25c0 9.320313 7.558594 16.878906 16.878906 16.878906h478.242188c9.320312 0 16.878906-7.558593 16.878906-16.878906v-43.25zm0 0",
    fill: "url(#linear23)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m58.898438 302.394531c0 10.902344-8.839844 19.742188-19.746094 19.742188-10.902344 0-19.742188-8.839844-19.742188-19.742188 0-10.90625 8.839844-19.746093 19.742188-19.746093 10.90625 0 19.746094 8.839843 19.746094 19.746093zm0 0",
    fill: "url(#linear24)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m48.003906 294.015625c-2.222656-2.347656-5.363281-3.824219-8.851562-3.824219-6.738282 0-12.199219 5.464844-12.199219 12.203125 0 3.488281 1.472656 6.628907 3.820313 8.851563l23.652343 23.652344c2.222657 2.347656 5.363281 3.820312 8.851563 3.820312 6.738281 0 12.203125-5.460938 12.203125-12.199219 0-3.492187-1.472657-6.628906-3.824219-8.855469zm0 0",
    fill: "url(#linear25)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m51.355469 302.394531c0 6.738281-5.464844 12.203125-12.203125 12.203125-6.738282 0-12.199219-5.464844-12.199219-12.203125s5.460937-12.203125 12.199219-12.203125c6.738281 0 12.203125 5.464844 12.203125 12.203125zm0 0",
    fill: "url(#linear26)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m104.742188 302.394531c0 10.902344-8.839844 19.742188-19.742188 19.742188-10.90625 0-19.746094-8.839844-19.746094-19.742188 0-10.90625 8.839844-19.746093 19.746094-19.746093 10.902344 0 19.742188 8.839843 19.742188 19.746093zm0 0",
    fill: "url(#linear27)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m93.851562 294.015625c-2.222656-2.347656-5.363281-3.824219-8.851562-3.824219-6.738281 0-12.203125 5.464844-12.203125 12.203125 0 3.488281 1.472656 6.628907 3.824219 8.851563l23.648437 23.652344c2.226563 2.347656 5.363281 3.820312 8.855469 3.820312 6.738281 0 12.199219-5.460938 12.199219-12.199219 0-3.492187-1.472657-6.628906-3.820313-8.855469zm0 0",
    fill: "url(#linear28)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m97.199219 302.394531c0 6.738281-5.460938 12.203125-12.199219 12.203125s-12.203125-5.464844-12.203125-12.203125 5.464844-12.203125 12.203125-12.203125 12.199219 5.464844 12.199219 12.203125zm0 0",
    fill: "url(#linear29)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m150.589844 302.394531c0 10.902344-8.839844 19.742188-19.746094 19.742188-10.902344 0-19.742188-8.839844-19.742188-19.742188 0-10.90625 8.839844-19.746093 19.742188-19.746093 10.90625 0 19.746094 8.839843 19.746094 19.746093zm0 0",
    fill: "url(#linear30)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m139.699219 294.015625c-2.226563-2.347656-5.363281-3.824219-8.855469-3.824219-6.738281 0-12.199219 5.464844-12.199219 12.203125 0 3.488281 1.472657 6.628907 3.820313 8.851563l23.652344 23.652344c2.222656 2.347656 5.363281 3.820312 8.851562 3.820312 6.738281 0 12.203125-5.460938 12.203125-12.199219 0-3.492187-1.472656-6.628906-3.824219-8.855469zm0 0",
    fill: "url(#linear31)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m143.046875 302.394531c0 6.738281-5.464844 12.203125-12.203125 12.203125s-12.203125-5.464844-12.203125-12.203125 5.464844-12.203125 12.203125-12.203125 12.203125 5.464844 12.203125 12.203125zm0 0",
    fill: "url(#linear32)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m512 266.839844v80.472656c0 9.328125-7.558594 16.886719-16.875 16.886719h-95.402344l-114.238281-114.238281h209.640625c9.316406 0 16.875 7.5625 16.875 16.878906zm0 0",
    fill: "url(#linear33)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m512 141.859375v80.476563c0 9.316406-7.558594 16.875-16.875 16.875h-220.390625l-16.695313-16.695313c-6.09375-6.105469-9.148437-14.09375-9.148437-22.085937 0-7.992188 3.054687-15.984376 9.148437-22.085938 12.195313-12.199219 31.972657-12.199219 44.171876 0l25.417968 25.417969c2.8125 2.8125 7.359375 2.8125 10.171875 0l78.777344-78.777344h78.546875c9.316406 0 16.875 7.558594 16.875 16.875zm0 0",
    fill: "url(#linear34)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m502.765625 112.40625c-2.300781 1.164062-4.890625 1.824219-7.640625 1.824219h-67.796875l16.597656-16.59375c12.195313-12.195313 31.972657-12.195313 44.171875 0zm0 0",
    fill: "url(#linear35)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m327.632812 203.761719-25.425781-25.421875c-12.195312-12.199219-31.972656-12.199219-44.171875 0-12.195312 12.199218-12.195312 31.976562 0 44.171875l38.003906 38.003906c20.257813 20.257813 53.097657 20.257813 73.351563 0l118.710937-118.707031c12.195313-12.199219 12.195313-31.976563 0-44.171875-12.199218-12.199219-31.976562-12.199219-44.175781 0l-106.125 106.125c-2.808593 2.808593-7.359375 2.808593-10.167969 0zm0 0",
    fill: "url(#linear36)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabase);
export default __webpack_public_path__ + "static/media/icon-database.d4f40419bcbdeaae8eec9e432fce1809.svg";
export { ForwardRef as ReactComponent };